import React from 'react';

import { VisibilityProvider } from './VisibilityProvider';
import Ads from '../../../sections/overview/dashboards/views/visibility/ads';
import Overview from '../../../sections/overview/dashboards/views/visibility/overview';
import SearchTermsAnalysis from '../../../sections/overview/dashboards/views/visibility/search-term-analysis';
import CompetitionEvolution from '../../../sections/overview/dashboards/views/visibility/competition-evolution';

export const AdsWithProvider: React.FC = () => (
    <VisibilityProvider>
        <Ads />
    </VisibilityProvider>
);

export const OverviewWithProvider: React.FC = () => (
    <VisibilityProvider>
        <Overview />
    </VisibilityProvider>
);

export const SearchTermsAnalysisWithProvider: React.FC = () => (
    <VisibilityProvider>
        <SearchTermsAnalysis />
    </VisibilityProvider>
);

export const CompetitionEvolutionWithProvider: React.FC = () => (
    <VisibilityProvider>
        <CompetitionEvolution />
    </VisibilityProvider>
);

export const VisibilityWithProvider = AdsWithProvider;
